"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreformattedElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const BlockPlaceholder_1 = require("./BlockPlaceholder");
const indentation_1 = require("../../behavior/indentation");
const font_1 = require("../../behavior/font");
const css_1 = require("../../custom-style/css");
const util_1 = require("../../util");
const preClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    mr: '1em 0',
    pd: '12px 14px',
    bdrad: '8px',
    ff: '"JetBrains Mono", "Fira Code", Menlo, monospace,' + nano_theme_1.font.mono.mid.ff,
    fz: '0.9rem',
    lh: 1.55,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    ovx: 'auto',
    tabSize: 4,
});
const PreformattedElement = ({ attributes, children, element }) => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("pre", { ...attributes, className: preClass, style: {
            textAlign: element.align,
            // marginInlineStart: indentPadding(element.indent) ?? 0,
            paddingInlineStart: 14 + ((0, indentation_1.indentPadding)(element.indent) ?? 0),
            marginInlineEnd: 0,
            fontFamily: (0, font_1.fontFamilyOf)(element.font),
            background: styles.g(0, 0.04),
            color: (0, css_1.fgVar)(16, styles.g(0.16)),
        } },
        children,
        (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
};
exports.PreformattedElement = PreformattedElement;
